import axios from 'axios'
import router from '../../router/index.js'

import _myThis from '@/main.js'//为了使用vux的loading
// create an axios instance
const service = axios.create({
    // 刘洋本地地址
    // baseURL : 'http://10.189.41.123/portal/loan/apply/6000',
    baseURL: process.env.BASE_API,
    timeout: 1000000, // request timeout,
})

// request interceptor
service.interceptors.request.use(config => {
    config.headers['x-frame-options'] = 'SAMEORIGIN'
    if (config.formType && config.formType === 1) {
        config.headers['Content-Type'] = 'application/x-www-form-urlencoded'
        config.transformRequest = [function(data) {
            // Do whatever you want to transform the data
            let ret = ''
            for (let it in data) {
                ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
            }
            return ret.substring(0, ret.length - 1)
        }]
    }
    if (config.formType && config.formType === 2) {
        config.headers['Content-Type'] = config.fileUploadHeaders['Content-Type']
        config.headers['client_id'] = config.fileUploadHeaders['client_id']
        config.headers['client_secret'] = config.fileUploadHeaders['client_secret']
    }
    if (config.formType && config.formType === 3) {
        config.headers['client_secret'] = config.fileUploadHeaders['client_secret']
        config.headers['client_id2'] = config.fileUploadHeaders['client_id2']
        config.headers['client_secret2'] = config.fileUploadHeaders['client_secret2']
        config.headers['client_id'] = config.fileUploadHeaders['client_id']
    }
    if (config.formType && config.formType === 4) {
        config.headers['dspSession'] = config.getKeyHeaders['dspSession']
        
    }
    if (config.showLoading) {
        showFullScreenLoading()
    }
    return config
}, error => {
    // Do something with request error
    Promise.reject(error)
})

// respone interceptor
service.interceptors.response.use(
    response => {
        /**
         * 下面的注释为通过response自定义code来标示请求状态，当code返回如下情况为权限有问题，登出并返回到登录页
         * 如通过xmlhttprequest 状态码标识 逻辑可写在下面error中
         */
        // 是否需要全局loading
        if (response.config.showLoading) {
            tryHideFullScreenLoading()
        }
        const res = response.data
       // 000405  实名认证 手机号认证失败
       // 网络连接超时也返回000000 通用超时(fbcode=0026) 贷款类型选择超时(fbcode=0036)
       // RECEIVED,SAVED 银行流水资料补充页面
        if (res.responseCode === '000000' || res.responseCode === '000405' || res.status === "RECEIVED" || res.status === "SAVED" ) {
            return res
        } else {
            if (res.responseCode === '000406') {
                _myThis.showToast(res.responseMessage+'！','15rem',4000)
                setTimeout(() => {
                    _myThis.$vux.toast.hide()
                    router.push({path:'/index'})
                }, 5000)
            } else if (res.responseCode === '000403') {
                _myThis.showToast(res.responseMessage+'！','15rem',4000)
                setTimeout(() => {
                    _myThis.$vux.toast.hide()
                    router.push({path:'/index'})
                }, 5000)
            } else if (res.responseCode === '000500') {
                    _myThis.showToast(res.responseMessage+'！','10rem')
            } else if (res.responseCode === undefined){

            } else{
                _myThis.showToast('网络异常，请稍后重试！','15rem')
            }
            return Promise.reject(res)
        }
    },
    error => {
        tryHideFullScreenLoading()
        console.log('interceptors',error.message)
        router.push({
            path:'/feedback',
            query:{code:'0026'},
        })
        return Promise.reject(error)
})

//加载封装
function startLoading() {
    _myThis.$vux.loading.show({
        text: '请稍等...'
    })
}
function endLoading() {
    _myThis.$vux.loading.hide()
}
let needLoadingRequestCount = 0
export function showFullScreenLoading() {
    if (needLoadingRequestCount === 0) {
        startLoading()
    }
    needLoadingRequestCount++
}
export function tryHideFullScreenLoading() {
    if (needLoadingRequestCount <= 0) return
    needLoadingRequestCount--
    if (needLoadingRequestCount === 0) {
        endLoading()
    }
}
export default service


// WEBPACK FOOTER //
// ./src/assets/utils/request.js